import React, { Component, createContext } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';

export const QueryCSContext = createContext();

class QueryCSContextProvider extends Component {
	state = {
		bundle: {},
		resource: {},
		apibase: '',
		apiurl:
			// 'http://tx.fhir.org/r4/CodeSystem?_sort=title&_count=15&_format=json',
			'https://r4.ontoserver.csiro.au/fhir/CodeSystem?_sort=title&_count=15',
		// https://r4.ontoserver.csiro.au/fhir/
		// https://ontoserver.dataproducts.nhs.uk/fhir/
		// http://int-dev-ontoserver-s-01.grhapp.com/fhir/
		// https://ontoserver.dataproducts.nhs.uk/fhir/CodeSystem?_sort=title&_count=15,
		filterName: '',
		filterTitle: '',
		filterTag: '',
		filterStatus: '',
		working: false
	};

	static contextType = GlobalContext;

	componentDidMount() {
		this.getData();
	}

	getNext = async () => {
		if (this.state.bundle.entry != null) {
			var nextUrl = this.state.bundle.link.filter(
				(x) => x.relation === 'next'
			);
			nextUrl = nextUrl[0].url;

			this.setState({ working: true });
			const response = await fetch(nextUrl);
			const jsonData = await response.json();
			this.setState({ working: false });
			this.setState({ bundle: jsonData });

			this.doAnalyticsEvent("Paging", "Next")
		}
	};

	getPrev = async () => {
		if (this.state.bundle.entry != null) {
			var prevUrl = this.state.bundle.link.filter(
				(x) => x.relation === 'previous'
			);
			prevUrl = prevUrl[0].url;

			this.setState({ working: true });
			const response = await fetch(prevUrl);
			const jsonData = await response.json();

			this.setState({ working: false });
			this.setState({ bundle: jsonData });

			this.doAnalyticsEvent("Paging", "Previous")
		}
	};

	doAnalyticsEvent(action, detail) {
		const { initAnalytics, logEventAnalytics } = this.context;
		initAnalytics();
		logEventAnalytics(
			"CodeSystem",
			action,
			detail);

		console.log("Log");
	}

	setApiBase = (name) => {
		// console.log('setting base', name);

		if (this.state.apibase !== name) {
			this.setState({ apibase: name });
		}
	};

	getData = async () => {
		const { tagSystem } = this.context;

		var qUrl = '';
		const nonce = Date.now();

		if (this.state.apibase === '') {
			qUrl = this.state.apiurl + '&_n=' + nonce;
			// qUrl = this.state.apiurl;
		} else {
			qUrl = this.state.abibase + 'CodeSystem?_sort=title&_count=15&_n=' + nonce;
			// qUrl = this.state.abibase + 'CodeSystem?_sort=title&_count=15';
		}

		var query = '';

		if (this.state.filterName !== '') {
			query = `&name:contains=${this.state.filterName}`;
		}

		if (this.state.filterTitle !== '') {
			query = query + `&title:contains=${this.state.filterTitle}`;
		}

		if (this.state.filterStatus !== '') {
			query = query + `&status=${this.state.filterStatus}`;
		}

		if (this.state.filterTag !== '') {
			query = query + encodeURI(`&_tag=${tagSystem}|${this.state.filterTag}`);
		}

		this.setState({ working: true });
		const response = await fetch(qUrl + query);
		const jsonData = await response.json();
		this.setState({ working: false });

		this.setState({ bundle: jsonData });

		if (query !== '') {
			this.doAnalyticsEvent("Query", query)
		}
	};

	getResource = async (x) => {
		const response = await fetch(
			'https://r4.ontoserver.csiro.au/fhir/CodeSystem/' + x
		);
		const jsonData = await response.json();
		this.setState({ resource: jsonData });
	};

	setFilterName = (name) => {
		this.setState({ filterName: name });
	};

	setFilterTag = (name) => {
		this.setState({ filterTag: name });
	};

	setFilterTitle = (title) => {
		this.setState({ filterTitle: title });
	};

	setFilterStatus = (status) => {
		this.setState({ filterStatus: status });
	};

	render() {
		return (
			<QueryCSContext.Provider
				value={{
					...this.state,
					getData: this.getData,
					getNext: this.getNext,
					getPrev: this.getPrev,
					getResource: this.getResource,
					setFilterName: this.setFilterName,
					setFilterTitle: this.setFilterTitle,
					setFilterTag: this.setFilterTag,
					setFilterStatus: this.setFilterStatus,
					setApiBase: this.setApiBase,
				}}
			>
				{this.props.children}
			</QueryCSContext.Provider>
		);
	}
}

export default QueryCSContextProvider;
